import React from 'react';
import { DivineBackdrop } from './shared';

const BlankDisplay = () => (
  <div className="w-full h-full relative overflow-hidden" data-testid="blank-display" style={{ height: '100vh' }}>
    <DivineBackdrop />
  </div>
);

export default BlankDisplay;
